/*********************************************************
 *                  Admin liste user Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin")
	   .controller("AdminUsersCtrl", ["$scope", "toastr", "AdminService", "users", "roles", "clients", "AdminUsersService", "Utils", "$uibModal", "AdminClientsService", "SecurityService", "$rootScope",
		   function ($scope, toastr, AdminService, users, roles, clients, AdminUsersService, Utils, $uibModal, AdminClientsService, SecurityService, $rootScope) {
		   /************************************************************************************************************
			*  SETUP
			*************************************************************************************************************/

		   var addEditModal;

		   $scope.data = {
			   users: users.data,
			   roles: roles.data,
			   clients: clients.data,
			   userToAddOrUpdate: {},
			   roleNameToGUIDisplay: {
				   ROLE_ADMINISTRATEUR: "Administrateur",
				   ROLE_COORDINATEUR: "Coordinateur",
				   ROLE_EXPLOITANT: "Exploitant",
				   ROLE_LECTEUR: "Lecteur",
				   ROLE_OPERATEUR: "Opérateur",
				   ROLE_SIMULATEUR: "Simulateur",
				   ROLE_SUPER_ADMINISTRATEUR: "Super administrateur",
			   }, // contains all users with at least one referential in common with client
			   usersFromReferential: [],
		   };

		   if (!SecurityService.hasRight("accessToAllClients")) {
			   $scope.data.clients = [...$rootScope.currentUserReferentials];
		   }

		   $scope.updateUsersFromReferential = () => {
			   if (SecurityService.hasRight("editUserFromReferential") || SecurityService.hasRight("deleteUserFromReferential")) {
				   $scope.data.usersFromReferential = [];
				   for (let i = 0; i < $scope.data.users.length; i++) {
					   let user = $scope.data.users[i];
					   if (user.roles.some(r => r.coordinateur || r.superAdmin)) {
						   // cannot update/delete coordinateur or super admin
						   continue;
					   }
					   AdminUsersService.getUser(user.keycloakUUID)
										.then(response => {
											const user = response.data;
											if (!user.clients || user.clients.length === 0) {
												return;
											}
											if ($scope.data.clients.some(client => user.clients.some(userClient => client.id === userClient.id))) {
												// users have a referential in common
												$scope.data.usersFromReferential.push(user.keycloakUUID);
											}
										});
				   }
			   }
		   };

		   $scope.updateUsersFromReferential();

		   $scope.canDeleteUser = (userToDelete) => {
			   if (SecurityService.hasRight("deleteUser")) {
				   return true;
			   }
			   if (SecurityService.hasRight("deleteUserFromReferential")) {
				   return $scope.data.usersFromReferential.includes(userToDelete.keycloakUUID);
			   }
			   return false;
		   };

		   $scope.canEditUser = (userToEdit) => {
			   if (SecurityService.hasRight("editUser")) {
				   return true;
			   }
			   if (SecurityService.hasRight("editUserFromReferential")) {
				   return $scope.data.usersFromReferential.includes(userToEdit.keycloakUUID);
			   }
			   return false;
		   };

		   $scope.canRemoveClientsFromUser = (userToAddOrUpdate, clientsToRemove) => {
			   if (!clientsToRemove || clientsToRemove.length === 0) {
				   return false;
			   }
			   return clientsToRemove.every(clientToRemove => $scope.data.clients.some(client => client.id === clientToRemove.id));
		   };

		   $scope.hasAnyRole = (user) => {
			   return user.roles.some(role => role.name.startsWith("ROLE_"));
		   };

		   $scope.openAddEditModal = function (user) {
			   $scope.data.userToAddOrUpdate = user || {};
			   if ($scope.data.userToAddOrUpdate.keycloakUUID) {
				   // user update
				   AdminUsersService.getUser($scope.data.userToAddOrUpdate.keycloakUUID)
									.then(response => {
										$scope.data.userToAddOrUpdate = response.data;
									});
			   } else {
				   $scope.data.userToAddOrUpdate.clients = [];
				   $scope.data.userToAddOrUpdate.roles = [];
			   }
			   addEditModal = Utils.openModal($uibModal, "addEdit.html", $scope);
		   };

		   $scope.addRole = (roleToAdd) => {
			   if (!angular.isArray($scope.data.userToAddOrUpdate.roles)) {
				   $scope.data.userToAddOrUpdate.roles = [];
			   }
			   // use set to avoid duplicates
			   $scope.data.userToAddOrUpdate.roles = [
				   ...new Set([
					   ...$scope.data.userToAddOrUpdate.roles,
					   roleToAdd
				   ])
			   ];
		   };

		   $scope.removeRole = (roleToRemove) => {
			   $scope.data.userToAddOrUpdate.roles = $scope.data.userToAddOrUpdate.roles.filter(role => roleToRemove.id !== role.id);
		   };

		   $scope.getAvailableRoles = () => {
			   return $scope.data.roles.filter(role => !$scope.data.userToAddOrUpdate.roles.some(userToAddOrUpdateRole => userToAddOrUpdateRole.id === role.id));
		   };

		   $scope.addClients = (clients) => {
			   if (!angular.isArray($scope.data.userToAddOrUpdate.clients)) {
				   $scope.data.userToAddOrUpdate.clients = [];
			   }
			   // use set to avoid duplicates
			   $scope.data.userToAddOrUpdate.clients = [
				   ...new Set([
					   ...$scope.data.userToAddOrUpdate.clients,
					   ...clients
				   ])
			   ];
		   };

		   $scope.addAllClients = () => {
			   $scope.data.userToAddOrUpdate.clients = [
				   ...$scope.getAvailableClients(),
				   ...$scope.data.userToAddOrUpdate.clients
			   ];
		   };

		   $scope.removeClients = (clients) => {
			   $scope.data.userToAddOrUpdate.clients = $scope.data.userToAddOrUpdate.clients.filter(userToAddOrUpdateClient => !clients.some(client => client.id === userToAddOrUpdateClient.id));
		   };

		   $scope.removeAllClients = () => {
			   $scope.removeClients($scope.data.clients);
		   };

		   $scope.getAvailableClients = () => {
			   return $scope.data.clients.filter(client => !$scope.data.userToAddOrUpdate.clients.some(userToAddOrUpdateClient => userToAddOrUpdateClient.id === client.id));
		   };

		   $scope.deleteUser = (userToDelete) => {
			   AdminService.deleteUser(userToDelete.keycloakUUID)
						   .then(() => {
							   $scope.data.users = $scope.data.users.filter(user => user.keycloakUUID !== userToDelete.keycloakUUID);
							   toastr.success("Utilisateur supprimé", "Utilisateur");
						   })
						   .catch(error => toastr.error(Utils.makeErrorMessage(error.data, "Erreur lors de la suppression de l'utilisateur"), "Erreur"));
		   };

		   $scope.saveUser = function () {
			   let isUpdate = !!$scope.data.userToAddOrUpdate.keycloakUUID;
			   const save = isUpdate ? AdminUsersService.editUser : AdminUsersService.addUser;
			   save($scope.data.userToAddOrUpdate)
			   .then(() => {
				   toastr.success("", isUpdate ? "Utilisateur mis à jour." : "Utilisateur ajouté.", "Utilisateur");
				   AdminUsersService.getAllUsers()
									.then((response) => {
										$scope.data.users = response.data;
										$scope.updateUsersFromReferential();
									});
				   addEditModal.close();
			   })
			   .catch(error => toastr.error(Utils.makeErrorMessage(error.data, isUpdate ? "Erreur lors de la mise à jour de l'utilisateur." : "Erreur lors de l'ajout de l'utilisateur."), "Erreur"));
		   };
	   }]);


